<template>
	<SectionCard title="Cessioni intracomunitarie B2B" icon="mdi-domain" subtitle="clienti UE con partita IVA · non imponibili art. 41, elenco Intrastat" no-padding data-tour="b2b">
		<template #actions>
			<v-btn small text color="primary" :loading="checking" :disabled="!report.vatPending" title="Verifica sul VIES le partite IVA non ancora controllate" @click="$emit('vat-check')">
				<v-icon small left>mdi-shield-check-outline</v-icon>
				Verifica sul VIES{{ report.vatPending ? ` (${report.vatPending})` : '' }}
			</v-btn>
		</template>
		<v-simple-table dense>
			<thead>
				<tr>
					<th style="width: 44px"></th>
					<th>Paese</th>
					<th class="text-right">Imponibile</th>
					<th class="text-right">Clienti</th>
					<th class="text-right">Ordini</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="c in report.intraB2b">
					<tr :key="c.country">
						<td>
							<v-btn icon small :title="open[c.country] ? 'Nascondi i clienti' : 'Mostra i clienti'" @click="toggle(c.country)">
								<v-icon small>{{ open[c.country] ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
							</v-btn>
						</td>
						<td>
							<span class="fo-code">{{ c.country }}</span> {{ c.name }}
						</td>
						<td class="text-right fo-strong">{{ formatEurCents(c.net) }}</td>
						<td class="text-right">{{ formatNumber(c.customers.length) }}</td>
						<td class="text-right">{{ formatNumber(c.orders) }}</td>
					</tr>
					<tr v-if="open[c.country]" :key="`${c.country}:detail`" class="fo-detail">
						<td colspan="5" class="pa-0">
							<v-simple-table dense class="fo-inner">
								<tbody>
									<tr v-for="x in c.customers" :key="x.vatId">
										<td class="fo-code">{{ x.vatId }}</td>
										<td>{{ x.name || '—' }}</td>
										<td>
											<v-chip x-small label outlined :color="vies(x.status).color">{{ vies(x.status).label }}</v-chip>
										</td>
										<td class="text-right">{{ formatEurCents(x.net) }}</td>
										<td class="text-right">{{ formatNumber(x.orders) }} ordini</td>
									</tr>
								</tbody>
							</v-simple-table>
						</td>
					</tr>
				</template>
				<tr v-if="!report.intraB2b.length">
					<td colspan="5" class="text-center grey--text py-4">Nessuna vendita a clienti UE con partita IVA nel periodo.</td>
				</tr>
			</tbody>
		</v-simple-table>
		<div class="fo-muted pa-3">
			B2B se l’ordine ha la partita IVA nell’indirizzo di fatturazione. Il VIES conferma la partita IVA: se la dice non valida la vendita passa in OSS. L’esito vale tre mesi, poi si ripete da solo.
		</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber } from '@/components/finance/format';
import { VIES } from './labels';

export default {
	name: 'ForeignB2b',
	components: { SectionCard },
	props: {
		report: { type: Object, required: true },
		checking: { type: Boolean, default: false },
	},
	data() {
		return { open: {} };
	},
	methods: {
		formatEurCents,
		formatNumber,
		vies: s => VIES[s] || VIES.unchecked,
		toggle(key) {
			this.$set(this.open, key, !this.open[key]);
		},
	},
};
</script>

<style scoped>
.fo-code {
	font-family: monospace;
	font-size: 12px;
	color: #5f6b7a;
}
.fo-strong {
	font-weight: 600;
}
.fo-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.fo-detail {
	background: #f8fafc;
}
.fo-inner {
	background: transparent !important;
}
</style>
